import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'
import dayjs from 'dayjs'

let loadingCount = 0

const service = axios.create({
  timeout: 10 * 1000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  autoAuth: true
})

const errorList = {
  unauthorized: { type: 'unauthorized', message: '未授权或授权过期' }
}

service.interceptors.request.use(
  config => {
    checkLoadingCount(config, 'add')
    return config
  },
  error => {
    checkLoadingCount(error.config, 'sub')
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    checkLoadingCount(response.config, 'sub')
    const res = response.data
    // 授权过期刷新页面
    if ((res.code === 9 || res.code === 5) && response.config.autoAuth) {
      Toast(errorList.unauthorized.message)
      setTimeout(() => {
        window.location.href = res.data.jump_url
      }, 1000)
      return Promise.reject(errorList.unauthorized)
    }
    return res
  },
  error => {
    checkLoadingCount(error.config, 'sub')
    if (error.message.indexOf('timeout') > -1) {
      Toast('连接超时，请重新再试')
    } else if (error.message.indexOf('Network Error') > -1) {
      Toast('网络错误，请重新再试')
    } else if (error.message.indexOf('Server Error') > -1) {
      Toast('服务器错误，请重新再试')
    } else {
      Toast(error.message)
    }
    return Promise.reject(error)
  }
)

const requestPlugin = {
  install(Vue, options) {
    const next = config => {
      return new Promise((resolve, reject) => {
        // 判断时间
        const nowTime = dayjs()
        let endTime = dayjs(options.endTime)
        // 判断结束时分秒是不是0，是0就加一天
        const endZero = !endTime.$H && !endTime.$m && !endTime.$s && !endTime.$ms
        endTime = endZero ? endTime.add(1, 'day') : endTime
        if (nowTime.isAfter(endTime)) {
          Toast('活动已结束')
          return
        }
        service
          .request(config)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
    Vue.prototype.$get = config => {
      const _config = {
        ...config,
        method: 'GET'
      }
      return next(_config)
    }
    Vue.prototype.$post = config => {
      const _config = {
        ...config,
        method: 'POST',
        data: qs.stringify(config.data)
      }
      return next(_config)
    }
  }
}

function checkLoadingCount(config, type) {
  if (!config.loading) {
    return
  }
  if (type === 'add') {
    loadingCount++
    if (loadingCount > 0) {
      Toast.loading({
        message: 'Loading...',
        duration: 0,
        forbidClick: true
      })
    }
  } else {
    loadingCount--
    if (loadingCount === 0) {
      Toast.clear()
    }
  }
}

export default requestPlugin
